function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Combobox as ComboboxPrimitive } from '@base-ui/react';
import { CheckIcon, ChevronDownIcon, XIcon } from 'lucide-react';
import * as React from 'react';
import { Button } from '../../components/ui/button';
import { InputGroup, InputGroupAddon, InputGroupButton, InputGroupInput } from '../../components/ui/input-group';
import { cn } from '../../lib/utils';
const Combobox = ComboboxPrimitive.Root;
function ComboboxValue(_0) {
    let {} = _0, props = _extends({}, _0);
    return /*#__PURE__*/ _jsx(ComboboxPrimitive.Value, _object_spread({
        "data-slot": "combobox-value"
    }, props));
}
function ComboboxTrigger(_0) {
    let { className, children } = _0, props = _object_without_properties(_0, [
        "className",
        "children"
    ]);
    return /*#__PURE__*/ _jsxs(ComboboxPrimitive.Trigger, _object_spread_props(_object_spread({
        "data-slot": "combobox-trigger",
        className: cn("[&_svg:not([class*='size-'])]:size-4", className)
    }, props), {
        children: [
            children,
            /*#__PURE__*/ _jsx(ChevronDownIcon, {
                "data-slot": "combobox-trigger-icon",
                className: "text-muted-foreground pointer-events-none size-4"
            })
        ]
    }));
}
function ComboboxClear(_0) {
    let { className } = _0, props = _object_without_properties(_0, [
        "className"
    ]);
    return /*#__PURE__*/ _jsx(ComboboxPrimitive.Clear, _object_spread_props(_object_spread({
        "data-slot": "combobox-clear",
        render: /*#__PURE__*/ _jsx(InputGroupButton, {
            variant: "ghost",
            size: "icon-xs"
        }),
        className: cn(className)
    }, props), {
        children: /*#__PURE__*/ _jsx(XIcon, {
            className: "pointer-events-none"
        })
    }));
}
function ComboboxInput(_0) {
    let { className, children, disabled = false, showTrigger = true, showClear = false } = _0, props = _object_without_properties(_0, [
        "className",
        "children",
        "disabled",
        "showTrigger",
        "showClear"
    ]);
    return /*#__PURE__*/ _jsxs(InputGroup, {
        className: cn('w-auto', className),
        children: [
            /*#__PURE__*/ _jsx(ComboboxPrimitive.Input, _object_spread({
                render: /*#__PURE__*/ _jsx(InputGroupInput, {
                    disabled: disabled
                })
            }, props)),
            /*#__PURE__*/ _jsxs(InputGroupAddon, {
                align: "inline-end",
                children: [
                    showTrigger && /*#__PURE__*/ _jsx(InputGroupButton, {
                        size: "icon-xs",
                        variant: "ghost",
                        asChild: true,
                        "data-slot": "input-group-button",
                        className: "group-has-data-[slot=combobox-clear]/input-group:hidden data-pressed:bg-transparent",
                        disabled: disabled,
                        children: /*#__PURE__*/ _jsx(ComboboxTrigger, {})
                    }),
                    showClear && /*#__PURE__*/ _jsx(ComboboxClear, {
                        disabled: disabled
                    })
                ]
            }),
            children
        ]
    });
}
function ComboboxContent(_0) {
    let { className, side = 'bottom', sideOffset = 6, align = 'start', alignOffset = 0, anchor } = _0, props = _object_without_properties(_0, [
        "className",
        "side",
        "sideOffset",
        "align",
        "alignOffset",
        "anchor"
    ]);
    return /*#__PURE__*/ _jsx(ComboboxPrimitive.Portal, {
        children: /*#__PURE__*/ _jsx(ComboboxPrimitive.Positioner, {
            side: side,
            sideOffset: sideOffset,
            align: align,
            alignOffset: alignOffset,
            anchor: anchor,
            className: "isolate z-50",
            children: /*#__PURE__*/ _jsx(ComboboxPrimitive.Popup, _object_spread({
                "data-slot": "combobox-content",
                "data-chips": !!anchor,
                className: cn('bg-popover text-popover-foreground data-open:animate-in data-closed:animate-out data-closed:fade-out-0 data-open:fade-in-0 data-closed:zoom-out-95 data-open:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 ring-foreground/10 *:data-[slot=input-group]:bg-input/30 *:data-[slot=input-group]:border-input/30 group/combobox-content relative max-h-96 w-(--anchor-width) max-w-(--available-width) min-w-[calc(var(--anchor-width)+--spacing(7))] origin-(--transform-origin) overflow-hidden rounded-md shadow-md ring-1 duration-100 data-[chips=true]:min-w-(--anchor-width) *:data-[slot=input-group]:m-1 *:data-[slot=input-group]:mb-0 *:data-[slot=input-group]:h-8 *:data-[slot=input-group]:shadow-none', className)
            }, props))
        })
    });
}
function ComboboxList(_0) {
    let { className } = _0, props = _object_without_properties(_0, [
        "className"
    ]);
    return /*#__PURE__*/ _jsx(ComboboxPrimitive.List, _object_spread({
        "data-slot": "combobox-list",
        className: cn('max-h-[min(calc(--spacing(96)---spacing(9)),calc(var(--available-height)---spacing(9)))] scroll-py-1 overflow-y-auto p-1 data-empty:p-0', className)
    }, props));
}
function ComboboxItem(_0) {
    let { className, children } = _0, props = _object_without_properties(_0, [
        "className",
        "children"
    ]);
    return /*#__PURE__*/ _jsxs(ComboboxPrimitive.Item, _object_spread_props(_object_spread({
        "data-slot": "combobox-item",
        className: cn("data-highlighted:bg-accent data-highlighted:text-accent-foreground relative flex w-full cursor-default items-center gap-2 rounded-sm py-1.5 pr-8 pl-2 text-sm outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4", className)
    }, props), {
        children: [
            children,
            /*#__PURE__*/ _jsx(ComboboxPrimitive.ItemIndicator, {
                "data-slot": "combobox-item-indicator",
                render: /*#__PURE__*/ _jsx("span", {
                    className: "pointer-events-none absolute right-2 flex size-4 items-center justify-center"
                }),
                children: /*#__PURE__*/ _jsx(CheckIcon, {
                    className: "pointer-events-none size-4 pointer-coarse:size-5"
                })
            })
        ]
    }));
}
function ComboboxGroup(_0) {
    let { className } = _0, props = _object_without_properties(_0, [
        "className"
    ]);
    return /*#__PURE__*/ _jsx(ComboboxPrimitive.Group, _object_spread({
        "data-slot": "combobox-group",
        className: cn(className)
    }, props));
}
function ComboboxLabel(_0) {
    let { className } = _0, props = _object_without_properties(_0, [
        "className"
    ]);
    return /*#__PURE__*/ _jsx(ComboboxPrimitive.GroupLabel, _object_spread({
        "data-slot": "combobox-label",
        className: cn('text-muted-foreground px-2 py-1.5 text-xs pointer-coarse:px-3 pointer-coarse:py-2 pointer-coarse:text-sm', className)
    }, props));
}
function ComboboxCollection(_0) {
    let {} = _0, props = _extends({}, _0);
    return /*#__PURE__*/ _jsx(ComboboxPrimitive.Collection, _object_spread({
        "data-slot": "combobox-collection"
    }, props));
}
function ComboboxEmpty(_0) {
    let { className } = _0, props = _object_without_properties(_0, [
        "className"
    ]);
    return /*#__PURE__*/ _jsx(ComboboxPrimitive.Empty, _object_spread({
        "data-slot": "combobox-empty",
        className: cn('text-muted-foreground hidden w-full justify-center py-2 text-center text-sm group-data-empty/combobox-content:flex', className)
    }, props));
}
function ComboboxSeparator(_0) {
    let { className } = _0, props = _object_without_properties(_0, [
        "className"
    ]);
    return /*#__PURE__*/ _jsx(ComboboxPrimitive.Separator, _object_spread({
        "data-slot": "combobox-separator",
        className: cn('bg-border -mx-1 my-1 h-px', className)
    }, props));
}
function ComboboxChips(_0) {
    let { className } = _0, props = _object_without_properties(_0, [
        "className"
    ]);
    return /*#__PURE__*/ _jsx(ComboboxPrimitive.Chips, _object_spread({
        "data-slot": "combobox-chips",
        className: cn('dark:bg-input/30 border-input focus-within:border-ring focus-within:ring-ring/50 has-aria-invalid:ring-destructive/20 dark:has-aria-invalid:ring-destructive/40 has-aria-invalid:border-destructive dark:has-aria-invalid:border-destructive/50 flex min-h-9 flex-wrap items-center gap-1.5 rounded-md border bg-transparent bg-clip-padding px-2.5 py-1.5 text-sm shadow-xs transition-[color,box-shadow] focus-within:ring-[3px] has-aria-invalid:ring-[3px] has-data-[slot=combobox-chip]:px-1.5', className)
    }, props));
}
function ComboboxChip(_0) {
    let { className, children, showRemove = true } = _0, props = _object_without_properties(_0, [
        "className",
        "children",
        "showRemove"
    ]);
    return /*#__PURE__*/ _jsxs(ComboboxPrimitive.Chip, _object_spread_props(_object_spread({
        "data-slot": "combobox-chip",
        className: cn('bg-muted text-foreground flex h-[calc(--spacing(5.5))] w-fit items-center justify-center gap-1 rounded-sm px-1.5 text-xs font-medium whitespace-nowrap has-disabled:pointer-events-none has-disabled:cursor-not-allowed has-disabled:opacity-50 has-data-[slot=combobox-chip-remove]:pr-0', className)
    }, props), {
        children: [
            children,
            showRemove && /*#__PURE__*/ _jsx(ComboboxPrimitive.ChipRemove, {
                render: /*#__PURE__*/ _jsx(Button, {
                    variant: "ghost",
                    size: "sm"
                }),
                className: "-ml-1 opacity-50 hover:opacity-100",
                "data-slot": "combobox-chip-remove",
                children: /*#__PURE__*/ _jsx(XIcon, {
                    className: "pointer-events-none"
                })
            })
        ]
    }));
}
function ComboboxChipsInput(_0) {
    let { className, children } = _0, props = _object_without_properties(_0, [
        "className",
        "children"
    ]);
    return /*#__PURE__*/ _jsx(ComboboxPrimitive.Input, _object_spread({
        "data-slot": "combobox-chip-input",
        className: cn('min-w-16 flex-1 outline-none', className)
    }, props));
}
function useComboboxAnchor() {
    return React.useRef(null);
}
export { Combobox, ComboboxChip, ComboboxChips, ComboboxChipsInput, ComboboxCollection, ComboboxContent, ComboboxEmpty, ComboboxGroup, ComboboxInput, ComboboxItem, ComboboxLabel, ComboboxList, ComboboxSeparator, ComboboxTrigger, ComboboxValue, useComboboxAnchor };
